import { Injectable } from '@angular/core';
import { AbstractScanner } from './scanner.types';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { BarcodeFormat } from '@zxing/library';

@Injectable({
  providedIn: 'root',
})
export class ScannerWebService
  implements AbstractScanner<BarcodeFormat[], MediaDeviceInfo>
{
  hasCameraPermission = new BehaviorSubject<boolean | null>(null);
  valueScanned: Subject<string> = new Subject<string>();
  errorEmitted: Subject<string> = new Subject<string>();
  camerasFound = new Subject<MediaDeviceInfo[]>();
  selectedCameraDevice$ = new BehaviorSubject<MediaDeviceInfo | undefined>(undefined);
  isRan: boolean = false;
  supportedFormats: BarcodeFormat[] = [
    BarcodeFormat.EAN_13,
    BarcodeFormat.EAN_8,
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.PDF_417,
    BarcodeFormat.CODE_93,
    BarcodeFormat.CODE_39,
    BarcodeFormat.QR_CODE,
    BarcodeFormat.UPC_A,
    BarcodeFormat.UPC_E,
    BarcodeFormat.ITF,
  ];

  constructor() {
    console.info('web scanner impl is used');
  }

  runScanner(): Observable<void> {
    this.isRan = true;
    return of(void 0);
  }

  stopScanner(): Observable<void> {
    this.isRan = false;
    return of(void 0);
  }

  setPermission(hasPermission: boolean): void {
    this.hasCameraPermission.next(hasPermission || false);
  }
}
